import request from '@/api/index'
import { getRequest, postRequest } from '../baseRequest'
import { filterEmptyParams } from '@/utils/formatObject'

// 查看表单
export const viewFormResultRequest = (formKey) => getRequest(`/user/form/data/view/${formKey}`)
// 保存表单结果数据
export const createFormResultRequest = (data) => postRequest('/user/form/data/create', data)
// 保存公开表单结果数据
export const publicCreateFormResultRequest = (url, data) => {
  return request({
    url,
    method: 'post',
    data: data
  })
}
// export const publicCreateFormResultRequest = (data) => postRequest('/user/form/data/public/create', data)
// 查询数据列表
export const listFormDataTableRequest = (data) => postRequest('/user/form/data/query', filterEmptyParams(data))
// 查询数据详情
export const getFormDataDetailsRequest = (dataId) => getRequest(`/user/form/data/details/${dataId}`)
// 删除数据
export const deleteFormDataRequest = (data, key) => postRequest(`/user/form/data/delete/${key}`, data)
// 修改数据
export const updateFormDataRequest = (data) => postRequest('/user/form/data/update', data)
// 导出附件
export const downloadFormDataFileRequest = (data) => postRequest('/user/form/data/download/file', data)
// 导出数据
export const exportDataRequest = (data) => postRequest('/user/form/data/export', data)

// 下载导入模板
export const downloadImportTemplateRequest = (params) => {
  return request({
    url: '/user/form/data/import/template',
    method: 'get',
    params: params,
    responseType: 'blob'
  })
}
// 批量标记已处理
export const setProcessed = (data) => postRequest('/user/form/data/activateProcessedStatus', data)

// 批量标记未处理
export const cancelProcessed = (data) => postRequest('/user/form/data/deactivateProcessedStatus', data)
// 批量标记已处理
export const setStarMarking = (data) => postRequest('/user/form/data/starMarking', data)

// 批量标记未处理
export const cancelStarMarking = (data) => postRequest('/user/form/data/disableStarMarking', data)

// 根据问卷数据id获取备注记录
export const getFormDataRemarksRecord = (data) => postRequest('/user/form/data/getFormDataRemarksRecord', data)

// 根据问卷数据id新增备注记录并返回最新数据
export const addRemarksRecord = (data) => postRequest('/user/form/data/addRemarksRecordAndReturnFirstPage', data)

// 根据备注记录id删除，并返回当前页数据
export const deleteRemarksRecord = (data) =>
  postRequest('/user/form/data/deleteRemarksRecordAndReturnCurrentPage', data)

// 保存评论数据
export const saveReplyRequest = (data) => postRequest('/user/form/data/reply', data)
// 查询回复列表
export const listReplyRequest = (params) => getRequest('/user/form/data/reply/list', params)
// 根据数据id查询备注内容
export const getRemarkRequest = (dataId) => getRequest(`/user/form/data/remark/${dataId}`)
// 保存备注内容
export const saveRemarkRequest = (data) => postRequest('/user/form/data/saveRemark', data)
// 获取门店组织架构
export const getAllShopList = () => getRequest('/shop/queryAllShop')

// 获取当前帐号拥有的门店组织
export const getUserValidShops = () => getRequest('/shop/getUserValidShops')
